import axios from 'axios'
import qs from 'qs'
import api from '@/api'


export default {

  // Objeto usuario
    user: {
      authenticated: false
    },
    setUserInfo (obj) {
      //Agregar SAED si es admin o coordinador
      //TODO enviar establecimiento SAED desde el servidor
      console.log(obj);
      var esadmin = false;
      for (var i = 0; i < obj.Roles.length; i++) {
        if (obj.Roles[i].Name.toLowerCase()==='admin' || obj.Roles[i].Name.toLowerCase()==='coordinador' ) {
          console.log('admin o coordinador');
          esadmin = true;
          break;
        }
      }
      if (esadmin) {
        obj.Establecimientos.unshift({
          Id:31,
          DisplayNivelAsignado: "SAED",
          NivelEnseñanza_Id: null,
          UnidadAdministrativa_Id: 1,
          UnidadEducativa_Id: null,
        });
      }
      window.sessionStorage.setItem('userInfo', JSON.stringify(obj));
    },
    setAuth (obj) {
      window.sessionStorage.setItem('token', JSON.stringify(obj));
    },
    getAuth () {
      console.log('getAuth', window.sessionStorage.getItem('token'))
      return JSON.parse(window.sessionStorage.getItem('token'))
    },
    clear () {
      window.sessionStorage.clear();
    },
    login(obj) {
      obj.grant_type = 'password'
      return axios.post( api.url + '/token', qs.stringify(obj))
    },
    // To log out, we just need to remove the token
    logout() {
      sessionStorage.clear()
      this.user.authenticated = false
    },
    getUserInfo() {
      if (window.sessionStorage.getItem("userInfo") !== null) {
        var userInfoObject = JSON.parse(window.sessionStorage.getItem('userInfo'));
        console.log('getUserInfo sessionStorage', userInfoObject);
        return userInfoObject;
      }
      console.log('getUserInfo axios');
      //check si existe el token antes de pedir el userinfo.
      if(window.sessionStorage.getItem("token") !== null){
        return axios.get(`${api.url}/Account/UserInfo`,{
          params:{
            'incluyeRoles':true,
            'incluyeEstablecimientos':true
          }
        })
      }
      return null;
    },
    getEstablecimiento() {
      if (window.sessionStorage.getItem("establecimiento") !== null) {
        var establecimientoObject = JSON.parse(window.sessionStorage.getItem('establecimiento'));
        console.log('getEstablecimiento sessionStorage', establecimientoObject);
        return establecimientoObject;
      }
      console.log('getEstablecimiento null');
      return null;
    },
    isInRole (role, roles) {
      var encontrado = false;
      if(roles){
        for (var i = 0; i < roles.length; i++) {
          if (roles[i].Name===role) {
            encontrado = true;
            break;
          }
        }
      }
      return encontrado;
    }
}



// WEBPACK FOOTER //
// ./src/auth/auth.js